import { createSlice } from '@reduxjs/toolkit';

const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    isOpen: false,
    isShown: true,
    childData: '',
    activeLink: '',
    tabLink: '', // New state for data from child
  },
  reducers: {
    toggleMenu: (state) => {
      state.isOpen = !state.isOpen;
    },
    setMenu: (state) => {
      state.isShown = !state.isShown;
    },
    setChildData: (state, action) => { // New reducer to set child data
      state.childData = action.payload;
    },
    setActiveLink: (state, action) => { // New reducer to set child data
      state.activeLink = action.payload;
    },
    setTabLink: (state, action) => { // New reducer to set child data
      state.tabLink = action.payload;
    },
  },
});

export const { toggleMenu, setMenu, setChildData, setActiveLink, setTabLink } = menuSlice.actions;
export default menuSlice.reducer;
